<template>
        <div class="card">
            <row class="mt-3">
              <h4 class="ml-5 "> Orders Detail </h4> 
            </row>
            <br>
            <row >
              <p class="ml-5"> Name: {{ data.name }}</p>
              <p class="ml-5"> Address: {{ data.address }} </p>
              <p class="ml-5"> Email: {{ data.email }} </p>
              <p class="ml-5"> Mobile Phone: {{ data.mobile_phone }} </p>
              <p class="ml-5"> Payment Status: {{ data.payment_status }} </p>
              <p class="ml-5"> Order Status: {{ data.order_status }} </p>
              <p class="ml-5"> Total Payment: {{ data.total }} </p>
              <p class="ml-5"> Code: {{ data.code }} </p>
              <img v-bind:src="getQR(data.code)" />
            </row>
            <br>
            <row >
              <label class="ml-5 mt-3 text-info" > Additional Field </label>
            </row>
            <row class="mt-3 ml-3">
              <table>
                <tr v-for="(arr, index) in form.form_field" :key="index">
                    <td>
                        {{ arr.label }}
                    </td>
                    <td>
                        {{ arr.value }}
                    </td>
                </tr>
              </table>
            </row>
            <br>
            <row >
              <label class="ml-5 mt-3 text-info" > Ticket Details </label>
            </row>
            <row class="mt-3 ml-3">
              <table>
                  <thead>
                  <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Price</th>
                      <th>Quantity</th>
                  </tr>
                  </thead>
                  <tr v-for="(arr, index) in data.order_details" :key="index">
                      <td>
                        {{ arr.type.name }}
                      </td>
                      <td>
                        {{ arr.type.description }}
                      </td>
                      <td>
                        IDR. {{ arr.type.price }}
                      </td>
                      <td>
                          {{ arr.qty }} Ticket
                      </td>
                  </tr>
              </table>
            </row>
            <br>
            <row >
              <label class="ml-5 mt-3 text-info" > Attendance Details </label>
            </row>
            <row class="mt-3 ml-3">
              <table>
                  <thead>
                  <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Price</th>
                      <th>Quantity</th>
                  </tr>
                  </thead>
                  <tr v-for="(arr, index) in data.order_attendances" :key="index">
                      <td>
                        {{ arr.type.name }}
                      </td>
                      <td>
                        {{ arr.type.description }}
                      </td>
                      <td>
                        IDR. {{ arr.type.price }}
                      </td>
                      <td>
                          {{ arr.qty }} Ticket
                      </td>
                  </tr>
              </table>
            </row>
<!-- <pre>{{ $data | json }}</pre> -->
</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import event from '@/services/event';

export default {
  

    data(){
        return{
          data:[],
          form:{
              event_id:'',
              name:'',
              adrress:'',
              email:'',
              phone:'',
              mobile_phone:'',
              total:'',
              form_field:[],
              custom_tickets:[],
              admission_fee:''
          },
          eventID:'',
          eventName:'',
          message:'',
          qrcode:''
        }
    },
    mounted() {
      this.loadData()
    },
    computed: {
        subtotalRow() {
          return this.form.custom_tickets.map((arr) => {
            return arr.total = Number(arr.qty * arr.price) || 0
          });
        },

        total() {
          return this.form.custom_tickets.reduce((total, item) => {
            return this.form.total = total + item.total;
          }, 0);
        }

    },
    methods: {
      loadData(){
        event.getEventbyID_getorderdetail(this.$route.query.id)
        .then(res => {
          this.data = res.data
          this.message = res.message
          this.eventName = res.data.name
          this.eventID = res.data.id
          this.form.event_id = res.data.id
          this.form.form_field = JSON.parse(res.data.form_field);
          this.form.custom_tickets = res.data.event_tickets;
          this.form.admission_fee = res.data.admission_fee;
          this.qrcode = "http://localhost:8005/api/getqrcode/".res.data.code;
        })  
      },   
      getQR(value){
        return 'http://localhost:8005/api/getqrcode/' + value;
      }
    }
}
</script>
